import { useMemo } from "react";
import VersatileLink from "@/components/VersatileLink";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TargetLink(_ref) {
  let {
    href,
    blank,
    className,
    children
  } = _ref;
  const target = useMemo(() => {
    return blank ? "_blank" : "_self";
  }, [blank]);
  if (/^(https?:\/\/|\/).+/.test(href)) {
    //httpsがついていた場合新しいタブで開く
    return /*#__PURE__*/_jsx(VersatileLink, {
      href: href,
      children: /*#__PURE__*/_jsx("a", {
        className: className,
        target: target,
        rel: "noreferrer noopener",
        children: children
      })
    });
  } else {
    return /*#__PURE__*/_jsx("a", {
      className: className,
      children: children
    });
  }
}